export default {
  trends: {
    title: "Trend",
    navigation: {
      gameSummary: "Riepilogo partita",
    },
    tabs: {
      player: "Giocatore",
      team: "Squadra",
      parlay: "Parlay",
      sgp: "SGP",
      stats: "Statistiche",
    },
    help: {
      title: "Trend",
      description: "Linemate usa questi segnali per mostrare forza e contesto dietro ogni trend.",
      items: {
        recentForm: "Percentuale di successo forma recente",
        headToHead: "Percentuale di successo scontri diretti",
        homeAway: "Percentuale di successo casa/trasferta",
        starter: "Percentuale di successo da titolare (Linemate+)",
        injuryImpact: "Impatto infortuni compagni (Linemate+)",
        opponentRank: "Ranking difensivo avversario (Linemate+)",
      },
    },
    empty: {
      noTrendsAvailable: "Nessun trend disponibile",
      clearFilters: "Cancella filtri",
      offseasonTitle: "Attualmente fuori stagione",
      minimumGames: "Servono almeno 3 partite",
    },
    analysis: {
      title: "Analisi trend",
      viewProfile: "Vedi profilo",
      addToMyPicks: "Aggiungi a Le mie scelte",
      removeFromMyPicks: "Rimuovi da Le mie scelte",
      addParlayToMyPicks: "Aggiungi parlay a Le mie scelte",
      removeParlay: "Rimuovi parlay",
      addLegToMyPicks: "Aggiungi leg a Le mie scelte",
      removeLegFromMyPicks: "Rimuovi leg da Le mie scelte",
      sections: {
        playerForm: "Forma giocatore",
        playerPerformance: "Prestazione giocatore",
        teamPerformance: "Prestazione squadra",
        teamForm: "Forma squadra",
        startingLineup: "Formazione iniziale",
        injuries: "Infortuni",
        startingPitcher: "Lanciatore partente",
        batterVsPitcher: "Battitore vs lanciatore",
        opponentDefensiveRank: "Ranking difensivo avversario",
        weather: "Meteo",
        lockedAdvancedTools: "Ottieni di più con Linemate+",
        parlayLegs: "Leg",
      },
      labels: {
        status: "Stato",
        player: "Giocatore",
        type: "Tipo",
        viewGames: "Vedi partite",
        quickCheckout: "Checkout rapido",
        showAll: "Mostra tutto",
        close: "Chiudi",
        openOnProvider: "Apri su {{provider}}",
        visitProvider: "Visita {{provider}}",
        recentForm: "Forma recente",
        headToHead: "Scontri diretti",
        location: "Posizione",
        lastFive: "Ultime 5",
        asStarter: "Da titolare",
        startingPitcher: "Lanciatore partente",
        overallRank: "Ranking complessivo",
        positionalRank: "Ranking posizionale",
        confirmed: "Confermato",
        expected: "Previsto",
        withoutPlayer: "Senza {{player}}",
        rankVsPosition: "Ranking vs {{position}}",
        impactOn: "Impatto su {{target}}",
        defensiveRankAgainst: "Ranking difensivo {{team}} ‧ {{betType}} contro",
        vsPitcher: "vs {{pitcher}}",
        atBatsSummary: "{{value}} {{stat}} in {{atBats}} turni alla battuta",
        gamesSuffix: " partite",
        noSignalsFound: "Nessun segnale trovato per questo trend",
        noStarterSignal: "Non c’è alcun segnale da titolare",
        noStartingLineupsYet: "Non ci sono ancora formazioni iniziali",
        noInjuryReportSignal: "Non c’è alcun segnale del report infortuni",
        noInjuries: "Al momento non ci sono infortuni",
      },
      summaryCards: {
        recentForm: "Forma recente",
        headToHead: "Scontri diretti",
        homeSplit: "Split in casa",
        awaySplit: "Split in trasferta",
        recordGames: "{{record}} partite",
        recordVs: "{{record}} vs {{opponent}}",
        recordAtHome: "{{record}} in casa",
        recordAway: "{{record}} in trasferta",
      },
      paywall: {
        title: "Sblocca l'analisi completa del trend",
        body: "Vedi l'impatto di ogni segnale avanzato.",
      },
      preview: {
        injuryImpact: "Report infortuni",
        opponentRank: "Ranking difensivo avversario",
        recordPlaceholder: "100% ⋅ 00 delle ultime 00 partite",
        opponentRankPlaceholder: "00º • Positivo",
        weatherPlaceholder: "Nuvoloso",
      },
      weatherDirections: {
        inToOut: "Da dentro a fuori",
        outToRight: "Da fuori a destra",
        outToIn: "Da fuori a dentro",
        inFromLeft: "Dentro da sinistra",
        inFromRight: "Dentro da destra",
        leftToRight: "Da sinistra a destra",
        outToLeft: "Da fuori a sinistra",
        rightToLeft: "Da destra a sinistra",
        unknown: "Sconosciuto",
      },
      hints: {
        addTrendToMyPicks: "Aggiungi questo trend a Le mie scelte per piazzare la scommessa",
        swipeToAddTrend: "Scorri a sinistra per aggiungere rapidamente un trend a Le mie scelte.",
        swipeAddLabel: "Aggiungi",
      },
      imageImport: {
        noPicksFound: "Nessuna scelta trovata",
        noPicksBody: "Non siamo riusciti ad abbinare scelte da questa immagine.",
        analyze: "Analizza",
      },
      gamelog: {
        title: "Gamelog",
        titleWithout: "Partite giocate senza {{name}}",
        chips: {
          last10: "Ultime 10",
          headToHead: "Scontri diretti",
          homeSplits: "Split in casa",
          awaySplits: "Split in trasferta",
          versusPitcher: "vs. {{pitcher}}",
        },
        headers: {
          hit: "Centrato",
          date: "Data",
          versus: "Contro",
          result: "Risultato",
          comp: "Comp",
        },
      },
    },
    stats: {
      sections: {
        records: "Record",
        headToHead: "Scontri diretti",
        last5Games: "Ultime 5 partite",
        rankings: "Ranking",
        injuries: "Infortuni",
        gameDetails: "Dettagli partita",
      },
      picker: {
        season: "Stagione",
        last5: "Ultime 5",
        headToHead: "Scontri diretti",
      },
      rows: {
        recentForm: "Ultime 5 partite",
        season: "Coppa del Mondo 2026",
        overall: "Complessivo",
        home: "Home",
        away: "Trasferta",
      },
      rankings: {
        for: "A FAVORE",
        against: "CONTRO",
      },
    },
  },
};
